import React from 'react';

import styles from './CustomTooltip.module.scss';

type CustomTooltipProps = {
  formatter?: (value: string) => string;
  label?: string;
  labels?: { [name: string]: string };
  active?: string;
  payload?: { name: string; value: string }[];
};

function CustomTooltip(props: CustomTooltipProps): React.JSX.Element {
  const { label, formatter = (value) => value, labels = {}, active, payload = [] } = props;

  if (active) {
    return (
      <div className={styles.container}>
        <p className={styles.labelHeader}>{label}</p>
        {payload.map(({ name, value }, idx) => (
          <p key={`tooltip-${name}-${value}-${idx}`} className="label">
            {`${labels[name] || name} : ${formatter(value.toString())}`}
          </p>
        ))}
      </div>
    );
  }

  return <div />;
}

export default CustomTooltip;
